const homePage = {
  title: 'Vagas e Oportunidades para',
  description:
    'Receba pedidos de serviços de graça e só pague para liberar o contato deles.',
};

const aboutPage = {
  title: 'Como o GetNinjas funciona?',
  description:
    'GetNinjas é a maior plataforma de contratação de serviços do Brasil. Conectamos Profissionais de todo o Brasil com pessoas solicitando serviço, atendendo com qualidade, facilidade e rapidez todos os tipos de necessidade.',
  descriptionImageOne: 'Pedidos de serviços chegando toda hora no seu celular.',
  descriptionImageTwo:
    'Veja todos os pedidos de graça, e invista apenas nos que gostar.',
  descriptionImageThree:
    'Compre moedas no aplicativo para desbloquear os contatos dos clientes.',
  descriptionImageFour: '100% do valor do serviço é seu. E sem mensalidade!',
};

const formData = {
  title: 'Vagas e Oportunidades para',
  description: 'Preencha os campos abaixo.',
  placeholder: 'Digite seu e-mail',
  sendButton: 'Cadastre-se gratuitamente',
};

const requestPage = {
  title: 'Precisando contratar um Eletricista?',
  description: 'Fale o que precisa, receba até 4 orçamentos, escolha o melhor.',
  buttonRequest: 'Solicitar serviço',
};

const requestService = {
  title: 'Precisando contratar um Profissional de',
};

export { homePage, aboutPage, formData, requestPage, requestService };
